
import React from 'react';
import { Typography } from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';
import { trackEventMatomo } from 'js/library/utils/helpers';

export const GoBack = (props) => {

    const location = props.location || '' ;

    return (
        <div>
            <Typography style={{ color: '#0089FF', cursor: 'pointer' }} variant="body2" onClick={() => {trackEventMatomo(location, 'tocar', 'botao', 'voltar'); window.history.back();}}>
                {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}> */}
                    <ArrowBackIos style={{ fontSize: '1.2rem', color: '#6E3296' }} /> 
                    {/* Retornar */}
                {/* </div> */}
			</Typography>
        </div>
    );
};

export default GoBack;